import React from "react";
import FirstSection from "./activation/FirstSection";
import SecondSection from "./activation/SecondSection";
import MultiKitSection from "./activation/MultiKitSection";

const ActivationCodeSection = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-6 lg:tw-gap-12">
      <MultiKitSection />
      <FirstSection />
      <SecondSection />
    </div>
  );
};

export default ActivationCodeSection;
